import Vue from 'vue'
import Vuex from 'vuex'
import VueWait from 'vue-wait'
import VuexPersistence from 'vuex-persist'
import localforage from 'localforage'
import Cookies from 'js-cookie'
import IdleVue from 'idle-vue'
import support from '../modules/support'
import auth from '../modules/auth'
import users from '../modules/users'
import customers from '../modules/customers'
import items from '../modules/items'
import itemTags from '../modules/item-tags'
import itemFilterGroups from '../modules/item-filter-groups'
import orders from '../modules/orders'
import priceDiscountGroupsToPriceDiscountLevels from '../modules/price-discount-groups-to-price-discount-levels'
import searchableData from '../modules/searchable-data'
import subsidiaries from '../modules/subsidiaries'
import usersToSubsidiaries from '../modules/users-to-subsidiaries'
import previousYearChannelPartnerCommitmentVsShipped from '../modules/previous-year-channel-partner-commitment-vs-shipped'
import yearToDateChannelPartnerCommitmentVsShipped from '../modules/year-to-date-channel-partner-commitment-vs-shipped'
import orderItemsPlaced from '../modules/order-items-placed'
import commission from '../modules/commission'

Vue.use(Vuex)
Vue.use(VueWait)

// const vuexCookie = new VuexPersistence({
//   restoreState: (key, storage) => {
//     console.log('restore', key, Cookies.getJSON(key))
//     return Cookies.getJSON(key)
//   },
//   saveState: (key, state) => {
//     Cookies.set(key, state)
//     console.log('save', key, state, Cookies.getJSON(key))
//     return true
//   },
//   modules: [
//       'support',
//       'auth',
//       'users',
//       'customers',
//       'items',
//       'itemFilterGroups',
//       'itemTags',
//       'orders',
//       'priceDiscountGroupsToPriceDiscountLevels',
//       'searchableData',
//       'subsidiaries',
//       'usersToSubsidiaries',
//       // 'previousYearChannelPartnerCommitmentVsShipped',
//       // 'yearToDateChannelPartnerCommitmentVsShipped',
//       'orderItemsPlaced',
//       // 'commission',
//   ]
// })

// const vuexLocalStorage = new VuexPersistence({
//   storage: window.sessionStorage,
//   modules: [
//       'support',
//       'auth',
//       'users',
//       'customers',
//       'items',
//       'itemFilterGroups',
//       'itemTags',
//       'orders',
//       'priceDiscountGroupsToPriceDiscountLevels',
//       'searchableData',
//       'subsidiaries',
//       'usersToSubsidiaries',
//       // 'previousYearChannelPartnerCommitmentVsShipped',
//       // 'yearToDateChannelPartnerCommitmentVsShipped',
//       'orderItemsPlaced',
//       // 'commission',
//   ]
// })


var vuexPersistanceLocalForage = localforage.createInstance({
  driver: localforage.INDEXEDDB,
  name: 'store',
});


const vuexLocalForage = new VuexPersistence({
  storage: vuexPersistanceLocalForage,
  asyncStorage: true,
  modules: [
    'support',
    'auth',
    'users',
    'customers',
    'items',
    'itemFilterGroups',
    'itemTags',
    'orders',
    'priceDiscountGroupsToPriceDiscountLevels',
    'searchableData',
    'subsidiaries',
    'usersToSubsidiaries',
    // 'previousYearChannelPartnerCommitmentVsShipped',
    // 'yearToDateChannelPartnerCommitmentVsShipped',
    'orderItemsPlaced',
    // 'commission',
  ]
})

const store = new Vuex.Store({
  modules: {
    support,
    auth,
    users,
    customers,
    items,
    itemFilterGroups,
    itemTags,
    orders,
    priceDiscountGroupsToPriceDiscountLevels,
    searchableData,
    subsidiaries,
    usersToSubsidiaries,
    // previousYearChannelPartnerCommitmentVsShipped,
    // yearToDateChannelPartnerCommitmentVsShipped,
    orderItemsPlaced,
    // commission
  },
  plugins: [
    // vuexCookie.plugin
    // vuexLocalStorage.plugin
    vuexLocalForage.plugin
  ]
})

const eventEmitter = new Vue()

Vue.use(IdleVue, { 
  store,
  eventEmitter,
  idleTime: 60000
})

export default store